/** generated by generate-export-buckets */
import { AppConfig, CapabilityApplications } from '@hcs/types';

import { APP_CONFIG_AEXP } from './AppConfigAexp.config';
import { APP_CONFIG_AGILE_SUITE } from './AppConfigAgileSuite.config';
import { APP_CONFIG_BULK_HPI } from './AppConfigBulkHpi.config';
import { APP_CONFIG_BULK_PROPERTY_DATA } from './AppConfigBulkPropertyData.config';
import { APP_CONFIG_BULK_RPI } from './AppConfigBulkRpi.config';
import { APP_CONFIG_CANARYAI } from './AppConfigCanaryAI.config';
import { APP_CONFIG_DEVELOPER_CENTER } from './AppConfigDeveloperCenter.config';
import { APP_CONFIG_DEXP } from './AppConfigDexp.config';
import { APP_CONFIG_MARKET_INSIGHTS } from './AppConfigMarketInsights.config';
import { APP_CONFIG_MARKET_PULSE } from './AppConfigMarketPulse.config';
import { APP_CONFIG_ORG_ADMIN } from './AppConfigOrgAdmin.config';
import { APP_CONFIG_PEXP } from './AppConfigPexp.config';
import { APP_CONFIG_PLATFORM } from './AppConfigPlatform.config';
import { APP_CONFIG_PORTFOLIO } from './AppConfigPortfolio.config';
import { APP_CONFIG_SAVED_LISTS } from './AppConfigSavedLists.config';
import { APP_CONFIG_USER_ADMIN } from './AppConfigUserAdmin.config';

export * from './AppConfigAccessSolutionsPlatform.config';
export * from './AppConfigAexp.config';
export * from './AppConfigAgileSuite.config';
export * from './AppConfigBulkHpi.config';
export * from './AppConfigBulkPropertyData.config';
export * from './AppConfigBulkRpi.config';
export * from './AppConfigCanaryAI.config';
export * from './AppConfigDeveloperCenter.config';
export * from './AppConfigDexp.config';
export * from './AppConfigMarketInsights.config';
export * from './AppConfigMarketPulse.config';
export * from './AppConfigOrgAdmin.config';
export * from './AppConfigPexp.config';
export * from './AppConfigPlatform.config';
export * from './AppConfigPortfolio.config';
export * from './AppConfigSavedLists.config';
export * from './AppConfigUserAdmin.config';

export const EXTERNAL_APP_CONFIGS = [
  APP_CONFIG_AEXP,
  APP_CONFIG_AGILE_SUITE,
  APP_CONFIG_BULK_HPI,
  APP_CONFIG_BULK_PROPERTY_DATA,
  APP_CONFIG_BULK_RPI,
  APP_CONFIG_DEVELOPER_CENTER,
  APP_CONFIG_DEXP,
  APP_CONFIG_MARKET_INSIGHTS,
  APP_CONFIG_MARKET_PULSE,
  APP_CONFIG_ORG_ADMIN,
  APP_CONFIG_PEXP,
  APP_CONFIG_PLATFORM,
  APP_CONFIG_PORTFOLIO,
  APP_CONFIG_SAVED_LISTS,
  APP_CONFIG_CANARYAI,
  APP_CONFIG_USER_ADMIN,
];

export const EXTERNAL_APP_CONFIGS_BY_KEY = EXTERNAL_APP_CONFIGS.reduce<
  Partial<Record<CapabilityApplications, AppConfig>>
>((data, appConfig) => {
  data[appConfig.applicationKey] = appConfig;
  return data;
}, {});
